<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-header class="title">
      <mat-card-title class="no-subtitle">Sequence Totals</mat-card-title>
      <button mat-icon-button color="primary" (click)="onCloseDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <app-data-box headerTitle="TAFB" class="mt-32">
        <div class="data-box-content text-sm">
          Time Away From Base. Total amount of time from first leg sign-in through last leg debrief.
        </div>
      </app-data-box>

      <app-data-box headerTitle="Greater" class="mt-24">
        <div class="data-box-content text-sm">
          The greater of scheduled or actual flight time for the sequence.
        </div>
      </app-data-box>

      <app-data-box headerTitle="P/C" class="mt-24">
        <div class="data-box-content text-sm">
          <div class="boxed-item-content">Total pay and credit for the sequence.</div>
          <ul class="boxed-item-content">
            <li>Generated from duty rig and/or deadhead time.</li>
          </ul>
          <a href="https://www.alliedpilots.org/LinkClick.aspx?fileticket=XFPWb-VlEDo%3d&portalid=0" target="_blank"
            class="link text-sm">
            <mat-icon [inline]="true">launch</mat-icon>
            Compass Duty Rig Guide
          </a>
        </div>
      </app-data-box>

      <app-data-box headerTitle="Total" class="mt-24">
        <div class="data-box-content text-sm">Greater + P/C</div>
      </app-data-box>
    </mat-card-content>
  </mat-card>
</div>